import { useQueryClient } from 'react-query';
import { AppSettings, QUERY_KEYS } from '@24i/nxg-sdk-photon';
import { useState } from 'react';
import { log } from '@24i/nxg-core-utils/src/logger';

import { FetchParams, FetchResult } from '../types';
import { useAppSettingsData } from '../../../context/AppSettingsData';
import { handleError } from '../../../utils/error';

export const useApplicationConfigurationFetch = (): FetchResult<AppSettings | null> => {
    const queryClient = useQueryClient();
    const { client: appSettingsDataClient } = useAppSettingsData();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<Error | undefined>(undefined);

    const fetch = async (params?: FetchParams): Promise<AppSettings | null> => {
        try {
            setIsLoading(true);
            setError(undefined);

            if (params?.forceRefresh) {
                await queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.config] });
            }

            return await queryClient.fetchQuery({
                queryKey: QUERY_KEYS.config,
                queryFn: appSettingsDataClient.fetchServiceConfig,
            });
        } catch (e) {
            const err = handleError(e, 'Failed to fetch application config');
            setError(err);
            log('Error fetching application config: ', err);
            return null;
        } finally {
            setIsLoading(false);
        }
    };

    return { fetch, isLoading, error };
};
